const getHourStringFromNumber = numericHour =>
  `${numericHour.toString().length === 1 ? `0${numericHour}` : numericHour}:00`;

export default getHourStringFromNumber;
